import { combineReducers } from "redux";
// import CheckReducer from "./reducer_checkUser";
import LoginReducer from "./reducer_login";
import ServiceReducer from "./reducer_service";
import ModalReducer from "./reducer_modal";
import SettingReducer from "./reducer_setting.js";
import PageReducer from "./reducer_page";
// import CmsReducer from "./reducer_cmslist";
// console.log('ServiceReducer is',ServiceReducer);
const rootReducer = combineReducers({
    auth: LoginReducer,
    service: ServiceReducer,
    modal: ModalReducer,
    setting: SettingReducer,
    info: PageReducer,
    // cmslist:CmsReducer,
});
export default rootReducer;